import * as types from '../../../../types/masters/styles/color/colorTypes';
import * as api from '../../../../../api/masters/styles/color/colorApi';

export const fetchColors = () => async (dispatch) => {
  dispatch({ type: types.FETCH_COLOR_REQUEST });
  try {
    const data = await api.fetchColors();
    dispatch({ type: types.FETCH_COLOR_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_COLOR_FAILURE, payload: error.message });
  }
};

export const addColor = (color) => async (dispatch) => {
  try {
    const res = await api.addColor(color);
    dispatch({ type: types.ADD_COLOR_SUCCESS, payload: res });
    dispatch(fetchColors());
  } catch (error) {
    dispatch({ type: types.COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateColor = (id, color) => async (dispatch) => {
  try {
    const res = await api.updateColor(id, color);
    dispatch({ type: types.UPDATE_COLOR_SUCCESS, payload: res });
    dispatch(fetchColors());
  } catch (error) {
    dispatch({ type: types.COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteColor = (id) => async (dispatch) => {
  try {
    await api.deleteColor(id);
    dispatch({ type: types.DELETE_COLOR_SUCCESS, payload: id });
    dispatch(fetchColors());
  } catch (error) {
    dispatch({ type: types.COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setColorEdit = (color) => ({
  type: types.SET_COLOR_EDIT,
  payload: color,
});

export const clearColorEdit = () => ({
  type: types.CLEAR_COLOR_EDIT,
}); 